import api from '../utils/api';

class PassengersApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .get("/passengers", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .post("/passengers", data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  createNew = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .post(`/passengers/createNew/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .patch(`/passengers/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .delete(`/passengers/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .get(`/passengers/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const passengersApi = new PassengersApi();
export default passengersApi;